export enum RewardRuleType {
    FriendsAdded = 'FriendsAdded',
    AchievementEarned = 'AchievementEarned',
    LevelReached = 'LevelReached',
    PromotedHealthyHabitChallengeScore ='PromotedHealthyHabitChallengeScore'
}
